/**
 * Tag all external links with a '-external' -modifier class.
 *
 * From: https://stackoverflow.com/a/18660968/17570791
 */

{
    let links = document.getElementsByTagName('a');
    for (let i = 0; i < links.length; i++) {
        if (links[i].protocol === 'http:' || links[i].protocol === 'https:') {
            if (links[i].host !== window.location.host) {
                links[i].className += ' -external';
            }
        }
    }
}
